<template>
    <div>
        <div class="logo">
            <div class="container">
                <router-link to="/" tag="div" class="img">
                    <img :src="webBaseInfo.logo" alt />
                </router-link>
                <div class="search">
                    <el-input
                        popper-class="my-autocomplete"
                        v-model.trim="q"
                        :debounce="500"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入相关搜索词：中文名称,CAS号,货号,关键字"
                        @keyup.enter.native="onSearch"
                        :trigger-on-focus="false"
                        style="width:400px"
                        @select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.cas }}</div>
                            <span class="addr">{{ item.chName }} {{ item.molecularFormula }} </span>
                        </template>
                    </el-input>
                    <el-button
                        class="input-btn"
                        slot="append"
                        icon="el-icon-search"
                        @click="onSearch()"
                        style="margin-left:-1px"
                        >搜索</el-button
                    >
                    <el-button class="input-btn" @click="importExcel">批量订购</el-button>
                </div>
                <div class="conect">
                    {{ webBaseInfo.phone }} <br /><span class="day"
                        >客服热线(工作日 周一至周五 8:30-17:30)</span
                    >
                </div>
            </div>

            <div class="logo showTop" v-if="showTop">
                <div class="container" style="justify-content: flex-start;">
                    <router-link to="/" tag="div" class="img">
                        <img :src="webBaseInfo.logo" alt />
                    </router-link>
                    <div class="search">
                        <el-autocomplete
                            popper-class="my-autocomplete"
                            v-model.trim="q"
                            :debounce="1000"
                            :fetch-suggestions="querySearch"
                            placeholder="请输入相关搜索词：中文名称,CAS号,货号,关键字"
                            @keyup.enter.native="onSearch"
                            :trigger-on-focus="false"
                            style="width:570px;"
                            @select="handleSelect"
                        >
                            <template slot-scope="{ item }">
                                <div class="name">{{ item.cas }}</div>
                                <span class="addr"
                                    >{{ item.chName }} {{ item.molecularFormula }}
                                </span>
                            </template>
                        </el-autocomplete>
                        <el-button
                            class="input-btn"
                            slot="append"
                            icon="el-icon-search"
                            @click="onSearch()"
                            style="margin-left:-1px"
                            >搜索</el-button
                        >
                        <el-button class="input-btn" @click="importExcel">批量订购</el-button>
                    </div>
                </div>
            </div>
            <!-- 批量下单 -->
            <el-dialog
                title="批量订购"
                :visible.sync="importVisible"
                width="60%"
                :close-on-click-modal="false"
                :append-to-body="true"
            >
                <div style="margin-bottom:20px">
                    您是不是忘记模板了,
                    <a type="success" @click="importTemplate" href="#">点击此处</a> 下载模板
                </div>
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    action="*"
                    :auto-upload="false"
                    :file-list="fileList"
                    :limit="1"
                    :on-change="excelChange"
                    :on-exceed="excelExceed"
                    :on-remove="handleRemove"
                >
                    <el-button slot="trigger" type="primary" size="mini">选取文件</el-button>
                    <el-button
                        style="margin-left: 10px;"
                        type="success"
                        @click="submitUpload"
                        size="mini"
                    >
                        上传数据</el-button
                    >
                    <div slot="tip" class="el-upload__tip" style="font-size:14px">
                        请按照模板上传文件，单次上传文件大小限 <font style="color:red">11M</font>
                    </div>
                </el-upload>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import * as apis from '../fetch/search';

import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'v-logo',
    data() {
        return {
            q: '',
            productType: 1,
            timeout: null,
            showTop: false,

            importVisible: false,
            fileList: [],
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'webBaseInfo']),
    },
    methods: {
        ...mapActions(['setreloadUserState']),
        importTemplate() {
            window.open(
                window.location.origin + '/download/excel-template/batchesOrderTemplate.xlsx',
            );
        },
        handleRemove(file, fileList) {
            this.fileList = fileList;
        },
        importExcel() {
            this.importVisible = true;
        },
        excelChange(file) {
            this.fileList.push(file.raw);
        },
        excelExceed(files) {
            this.fileList = [];
            this.fileList.push(files[0]);
        },
        submitUpload() {
            if (!this.userInfo) {
                this.$message.info('亲，批量下单需要您先登录账号');
                return;
            }
            const isLt11M = this.fileList[0].size / 1024 / 1024 < 11;
            if (!isLt11M) {
                this.$message.error('上传文件大小不能超过 11MB!');
            } else {
                apis.upFile({ file: this.fileList[0] }).then(() => {
                    this.importVisible = false;
                    this.setreloadUserState(true);
                });
            }
        },
        onSearch() {
            // if (this.productType === 1) {
            //     this.$router.push({
            //         path: '/search',
            //         query: { q: this.q },
            //     });
            // }

            // if (this.productType === 2) {
            apis.returnCategory({ content: this.q }).then(res => {
                if (res.data && res.data.length == 1) {
                    this.$router.push({
                        path: '/product-list/' + res.data[0],
                        query: { q: this.q },
                    });
                } else {
                    this.$router.push({
                        path: '/materSearch',
                        query: { q: this.q },
                    });
                }
            });
            // this.$router.push({
            //     path: '/materSearch',
            //     query: { q: this.q },
            // });
            // }

            // apis.searchLogsave({ searchContent: this.q, type: this.productType }).then(() => {});
        },
        handleSelect(item) {
            this.q = item.cas;
            this.onSearch();
        },
        querySearch(queryString, cb) {
            apis.queryListByCasCode({ cas: queryString.trim() }).then(res => {
                if (res.data != null) {
                    cb(res.data);
                } else {
                    cb([]);
                }
            });
        },
        handleScroll() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            if (top > 300) {
                this.showTop = true;
            } else {
                this.showTop = false;
            }
        },
    },
    created() {
        setTimeout(() => {
            this.productType = parseInt(this.$route.query.type) || 1;
            this.q = this.$route.query.q || '';
        }, 200);
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll, true);
    },
    watch: {
        '$route.query.q'(val) {
            this.q = this.$route.query.q || '';
        },
    },
};
</script>

<style lang="less">
.search {
    .el-input__inner {
        border-radius: 0;
    }
}
</style>

<style lang="less" scoped>
.name {
    text-overflow: ellipsis;
    overflow: hidden;
}
.addr {
    font-size: 12px;
    color: #b4b4b4;
}
.logo {
    padding: 16px 0;
    .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .img {
            cursor: pointer;
            width: 150px;
            height: 60px;
            img {
                // width: 100%;
                height: 64px;
            }
        }
        .search {
            .type {
                display: inline-block;
                width: 100px;
                text-align: center;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #898d9f;
                cursor: pointer;
            }
            .active {
                background: var(--theme-color);
                color: #ffffff;
            }
            .el-input {
                width: 500px;
                margin-right: 20px;
            }
            .input-btn {
                background-color: var(--theme-color);
                border-radius: 0 4px 4px 0;
                color: #fff;
            }
            .search-btn {
                background-color: var(--theme-color);
            }
        }
        .conect {
            font-size: 18px;
            color: var(--theme-color);
            .day {
                font-size: 14px;
                color: #666666;
            }
        }
    }
}
.showTop {
    position: fixed;
    padding: 20px 0;
    margin: 0;
    width: 100%;
    top: 0;
    background: #ffffff;
    z-index: 99;
    box-shadow: 0 4px 20px #0000001a;
}
</style>
